import { MobileState } from './Types';
import { MobileActionTypes, MobileActions } from './action';

const initialState: MobileState = {
    bannerClosed: false,
};

function mobileReducer(state: MobileState = initialState, action: MobileActionTypes): MobileState {
    switch (action.type) {
        case MobileActions.CLOSE_BANNER: {
            return {
                ...state,
                bannerClosed: true,
            };
        }
        default: {
            return state;
        }
    }
}

export default mobileReducer;
